module.exports = __webpack_public_path__ + "static/media/Daniel_Edminster_CV_9_20.128ff1df.pdf";